import GroupHeader from "./GroupHeader";
import MainGroup from "./MainGroup";
import SubAccount from "./SubAccount";
import Account from "./Account";

interface ConfigServiceProps {
    name: string;
    id: number;
    onClose: () => void;
}

const ConfigService = ({ name, id, onClose }: ConfigServiceProps) => {
    if (name === "Group Header") {
        return <GroupHeader onClose={() => onClose()} id={id} />
    }
    if (name === "Main Group") {
        return <MainGroup onClose={() => onClose()} id={id} />
    }
    if (name === "Sub Account") {
        return <SubAccount onClose={() => onClose()} id={id} />
    }
    if (name === "Account") {
        return <Account onClose={() => onClose()} id={id} />
    }

}
export default ConfigService;